import Alert from '@/components/Atoms/Icons/Alert';
import Apple from '@/components/Atoms/Icons/Apple';
import Appointment from '@/components/Atoms/Icons/Appointment';
import AppointmentSelected from '@/components/Atoms/Icons/AppointmentSelected';
import ArrowBack from '@/components/Atoms/Icons/ArrowBack';
import Articles from '@/components/Atoms/Icons/Articles';
import ArticlesSelected from '@/components/Atoms/Icons/ArticlesSelected';
import Bell from '@/components/Atoms/Icons/Bell';
import Bulb from '@/components/Atoms/Icons/Bulb';
import Calendar from '@/components/Atoms/Icons/Calendar';
import CheckboxOff from '@/components/Atoms/Icons/CheckboxOff';
import CheckboxOn from '@/components/Atoms/Icons/CheckboxOn';
import CheckCircle from '@/components/Atoms/Icons/CheckCircle';
import CircleEmpty from '@/components/Atoms/Icons/CircleEmpty';
import CircleFull from '@/components/Atoms/Icons/CircleFull';
import CompassVariableColor from '@/components/Atoms/Icons/CompassVariableColor';
import CompassVariableColorSelected from '@/components/Atoms/Icons/CompassVariableColorSelected';
import Cross from '@/components/Atoms/Icons/Cross';
import Crosshair from '@/components/Atoms/Icons/Crosshair';
import DashboardArrowLeft from '@/components/Atoms/Icons/DashboardArrowLeft';
import DashboardArrowRight from '@/components/Atoms/Icons/DashboardArrowRight';
import DashboardChevronDown from '@/components/Atoms/Icons/DashboardChevronDown';
import DashboardChevronRight from '@/components/Atoms/Icons/DashboardChevronRight';
import DashboardThumbsDown from '@/components/Atoms/Icons/DashboardThumbsDown';
import DashboardThumbsUp from '@/components/Atoms/Icons/DashboardThumbsUp';
import Dropdown from '@/components/Atoms/Icons/Dropdown';
import DropSmall from '@/components/Atoms/Icons/DropSmall';
import Exclamations from '@/components/Atoms/Icons/Exclamations';
import EyeClose from '@/components/Atoms/Icons/EyeClose';
import EyeOpen from '@/components/Atoms/Icons/EyeOpen';
import Facebook from '@/components/Atoms/Icons/Facebook';
import FileUploaded from '@/components/Atoms/Icons/FileUploaded';
import Google from '@/components/Atoms/Icons/Google';
import GridView from '@/components/Atoms/Icons/GridView';
import Home from '@/components/Atoms/Icons/Home';
import HomeSelected from '@/components/Atoms/Icons/HomeSelected';
import Info from '@/components/Atoms/Icons/Info';
import ListView from '@/components/Atoms/Icons/ListView';
import Lock from '@/components/Atoms/Icons/Lock';
import Logout from '@/components/Atoms/Icons/Logout';
import Menu from '@/components/Atoms/Icons/Menu';
import NewTab from '@/components/Atoms/Icons/NewTab';
import OpenLink from '@/components/Atoms/Icons/OpenLink';
import Play from '@/components/Atoms/Icons/Play';
import Point from '@/components/Atoms/Icons/Point';
import Prevention from '@/components/Atoms/Icons/Prevention';
import PreventionSelected from '@/components/Atoms/Icons/PreventionSelected';
import Question from '@/components/Atoms/Icons/Question';
import QuestionSelected from '@/components/Atoms/Icons/QuestionSelected';
import Questionmark from '@/components/Atoms/Icons/Questionmark';
import QuestionMarkCircle from '@/components/Atoms/Icons/QuestionMarkCircle';
import RadioOn from '@/components/Atoms/Icons/RadioOn';
import RadioOff from '@/components/Atoms/Icons/RadioOff';
import Search from '@/components/Atoms/Icons/Search';
import Settings from '@/components/Atoms/Icons/Settings';
import Success from '@/components/Atoms/Icons/Success';
import Star from '@/components/Atoms/Icons/Star';
import StarFilled from '@/components/Atoms/Icons/StarFilled';
import StateRejected from '@/components/Atoms/Icons/StateRejected';
import StateScheduled from '@/components/Atoms/Icons/StateScheduled';
import StateScheduling from '@/components/Atoms/Icons/StateScheduling';
import StateSearching from '@/components/Atoms/Icons/StateSearching';
import StateSos from '@/components/Atoms/Icons/StateSos';
import StateWaiting from '@/components/Atoms/Icons/StateWaiting';
import StateWaitingAlt from '@/components/Atoms/Icons/StateWaitingAlt';
import Tick from '@/components/Atoms/Icons/Tick';
import Times from '@/components/Atoms/Icons/Times';
import Trash from '@/components/Atoms/Icons/Trash';
import Warning from '@/components/Atoms/Icons/Warning';
import Chat from '@/components/Atoms/Icons/Chat';
import ChatSelected from '@/components/Atoms/Icons/ChatSelected';
import CalendarSelected from '@/components/Atoms/Icons/CalendarSelected';
import Bin from '@/components/Atoms/Icons/Bin';

const iconArray = [
  Alert,
  Apple,
  Appointment,
  AppointmentSelected,
  ArrowBack,
  Articles,
  ArticlesSelected,
  Chat,
  ChatSelected,
  CalendarSelected,
  Bin,
  Bell,
  Bulb,
  Calendar,
  CheckboxOn,
  CheckboxOff,
  CheckCircle,
  CircleEmpty,
  CircleFull,
  CompassVariableColor,
  CompassVariableColorSelected,
  Cross,
  Crosshair,
  DashboardArrowLeft,
  DashboardArrowRight,
  DashboardChevronDown,
  DashboardChevronRight,
  DashboardThumbsDown,
  DashboardThumbsUp,
  Dropdown,
  DropSmall,
  Exclamations,
  EyeClose,
  EyeOpen,
  Facebook,
  FileUploaded,
  Google,
  GridView,
  Home,
  HomeSelected,
  Info,
  ListView,
  Lock,
  Logout,
  Menu,
  NewTab,
  OpenLink,
  Play,
  Point,
  Prevention,
  PreventionSelected,
  Question,
  QuestionSelected,
  Questionmark,
  QuestionMarkCircle,
  RadioOn,
  RadioOff,
  Search,
  Settings,
  Success,
  Star,
  StarFilled,
  StateRejected,
  StateScheduled,
  StateScheduling,
  StateSearching,
  StateSos,
  StateWaiting,
  StateWaitingAlt,
  Tick,
  Times,
  Trash,
  Warning
];

export default iconArray.reduce((components, component) => {
  const iconName = `${component.name.charAt(0).toLowerCase()}${component.name.slice(1)}`;

  return {
    ...components,
    [iconName]: {
      component
    }
  };
}, {});
